/**
 * Kader Çarkı Widget (Portable)
 * Kullanım:
 * 1. Bu dosyayı ve wheel.css'i sayfanıza ekleyin.
 * 2. `const wheel = new WheelWidget({ categories: [], products: [] });` ile başlatın.
 * 3. `wheel.open()` ile çarkı açın.
 */

class WheelWidget {
    constructor(data) {
        this.data = data; // { categories: [], products: [] }
        this.state = {
            selectedCat: null,
            isSpinning: false
        };
        this.init();
    }

    init() {
        if (document.getElementById('wheel-widget-modal')) return; // Already exists
        this.injectHTML();
        this.bindEvents();
    }

    injectHTML() {
        const modalHtml = `
        <div id="wheel-widget-modal" class="fixed inset-0 z-[9999] hidden font-sans">
            <div class="absolute inset-0 bg-black/90 backdrop-blur-sm" id="wheel-backdrop"></div>
            <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md p-4">
                <div class="bg-[#111] text-white rounded-3xl p-6 relative text-center border border-amber-500/20 shadow-2xl overflow-hidden">
                    
                    <!-- Close Button -->
                    <button id="wheel-close-btn" class="absolute top-4 right-4 text-gray-400 hover:text-white w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors z-20">
                        <i class="fa-solid fa-times text-xl"></i>
                    </button>

                    <!-- Background Blobs -->
                    <div class="absolute top-0 right-0 w-32 h-32 bg-amber-500/10 rounded-full blur-3xl pointer-events-none"></div>
                    
                    <!-- Step 1: Categories -->
                    <div id="ww-step-1" class="transition-all duration-300 relative z-10">
                        <div class="w-16 h-16 mx-auto bg-amber-500/10 rounded-full flex items-center justify-center mb-4 text-amber-500">
                            <i class="fa-solid fa-dharmachakra text-3xl"></i>
                        </div>
                        <h2 class="text-2xl font-bold mb-2 text-amber-500">Kararsızlara Özel</h2>
                        <p class="text-gray-400 text-sm mb-6">Hangi kategoriden seçim yapalım?</p>
                        <div id="ww-cat-list" class="space-y-3 max-h-[50vh] overflow-y-auto pr-2 custom-scrollbar"></div>
                    </div>

                    <!-- Step 2: Spinner -->
                    <div id="ww-step-2" class="hidden flex-col items-center transition-all duration-300 relative z-10">
                        <h2 class="text-xl font-bold text-amber-500 mb-6">Döndür Gelsin!</h2>
                        <div class="relative w-64 h-64 mb-8">
                            <div class="absolute -top-4 left-1/2 -translate-x-1/2 z-20 text-white drop-shadow-md text-3xl">
                                <i class="fa-solid fa-caret-down text-amber-500"></i>
                            </div>
                            <div id="ww-spinner" class="w-full h-full rounded-full border-[6px] border-amber-500/30 relative" 
                                 style="background: conic-gradient(from 0deg, #222 0%, #111 100%); transition: transform 4s cubic-bezier(0.17, 0.67, 0.12, 0.99);"></div>
                             <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#111] rounded-full border-2 border-amber-500 z-10 flex items-center justify-center">
                                <i class="fa-solid fa-star text-amber-500 text-sm"></i>
                            </div>
                        </div>
                        <button id="ww-spin-btn" class="w-full bg-amber-500 hover:bg-amber-400 text-black font-bold py-3 rounded-xl transition-all shadow-lg active:scale-95">
                            ÇEVİR
                        </button>
                    </div>

                    <!-- Step 3: Result -->
                    <div id="ww-step-3" class="hidden transition-all duration-300 relative z-10">
                        <div class="w-24 h-24 mx-auto rounded-full bg-amber-500/20 flex items-center justify-center mb-6 animate-bounce">
                            <i class="fa-solid fa-gift text-4xl text-amber-500"></i>
                        </div>
                        <h3 class="text-sm text-gray-400 uppercase tracking-widest mb-4">Kaderin Seçimi</h3>
                        
                        <!-- Result Card -->
                        <div class="bg-white/5 rounded-2xl p-4 mb-6 border border-white/10">
                            <img id="ww-result-img" src="" class="w-full h-32 object-cover rounded-lg mb-3 hidden">
                            <div id="ww-result-name" class="text-2xl text-white font-bold mb-1"></div>
                            <div id="ww-result-desc" class="text-sm text-gray-400 mb-3 line-clamp-2"></div>
                            <div id="ww-result-price" class="text-xl text-amber-500 font-bold"></div>
                        </div>
                        
                        <div class="flex flex-col gap-3">
                            <button id="ww-reset-btn" class="bg-amber-500 text-black py-3 rounded-xl font-bold hover:bg-amber-400 transition-colors">
                                Tekrar Dene
                            </button>
                            <button id="ww-detail-btn" class="bg-white/10 text-white py-3 rounded-xl font-bold hover:bg-white/20 transition-colors hidden">
                                Ürün Detayı
                            </button>
                        </div>
                    </div>

                    <!-- Loader -->
                    <div id="ww-loader" class="hidden absolute inset-0 z-50 flex items-center justify-center bg-[#111]">
                        <i class="fa-solid fa-circle-notch fa-spin text-4xl text-amber-500"></i>
                    </div>

                </div>
            </div>
        </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHtml);
    }

    bindEvents() {
        document.getElementById('wheel-close-btn').onclick = () => this.close();
        document.getElementById('wheel-backdrop').onclick = () => this.close();
        document.getElementById('ww-reset-btn').onclick = () => this.reset();
        document.getElementById('ww-detail-btn').onclick = () => this.goToProduct();
    }

    open(catId = null) {
        const modal = document.getElementById('wheel-widget-modal');
        modal.classList.remove('hidden');
        this.renderCategories();

        if (catId) {
            // If category is pre-selected, don't show the list (Step 1)
            document.getElementById('ww-step-1').classList.add('hidden');
            document.getElementById('ww-step-2').classList.add('hidden');
            document.getElementById('ww-step-3').classList.add('hidden');

            const loader = document.getElementById('ww-loader');
            if (loader) {
                loader.classList.remove('hidden');
                loader.classList.add('flex');
            }

            this.setupWheel(catId);
        } else {
            this.resetUI();
        }
    }

    close() {
        document.getElementById('wheel-widget-modal').classList.add('hidden');
        this.state.isSpinning = false;
    }

    reset() {
        this.resetUI();
    }

    goToProduct() {
        if (this.state.lastProduct && typeof this.data.onGoToProduct === 'function') {
            this.close();
            this.data.onGoToProduct(this.state.lastProduct);
        }
    }

    resetUI() {
        document.getElementById('ww-step-1').classList.remove('hidden');
        document.getElementById('ww-step-2').classList.add('hidden');
        document.getElementById('ww-step-2').classList.remove('flex');
        document.getElementById('ww-step-3').classList.add('hidden');

        const loader = document.getElementById('ww-loader');
        if (loader) {
            loader.classList.add('hidden');
            loader.classList.remove('flex');
        }
    }

    renderCategories() {
        const list = document.getElementById('ww-cat-list');
        list.innerHTML = '';
        this.data.categories.forEach(cat => {
            const btn = document.createElement('button');
            const name = cat.name_tr || cat.name_en || cat.name || 'Category';
            btn.className = 'w-full text-left p-4 rounded-xl bg-white/5 border border-white/5 hover:border-amber-500 hover:bg-amber-500/10 transition-all group flex items-center justify-between text-white';
            btn.innerHTML = `
                <div class="flex items-center gap-3">
                   ${cat.image ? `<img src="${cat.image}" class="w-8 h-8 rounded-full object-cover">` : ''}
                   <span class="font-medium">${name}</span>
                </div>
                <i class="fa-solid fa-chevron-right text-gray-600 group-hover:text-amber-500"></i>
            `;
            btn.onclick = () => this.setupWheel(cat.id);
            list.appendChild(btn);
        });
    }

    async setupWheel(catId) {
        let products = [];
        if (typeof this.data.fetchProducts === 'function') {
            try {
                // Show loading or something if needed, but for now simple await
                products = await this.data.fetchProducts(catId);
            } catch (e) {
                console.error(e);
                alert('Ürünler yüklenemedi.');
                this.resetUI();
                return;
            }
        } else {
            products = this.data.products.filter(p => p.categoryId === catId);
        }

        if (products.length === 0) {
            alert('Bu kategoride ürün yok');
            this.resetUI();
            return;
        }

        document.getElementById('ww-step-1').classList.add('hidden');

        const loader = document.getElementById('ww-loader');
        if (loader) {
            loader.classList.add('hidden');
            loader.classList.remove('flex');
        }

        const step2 = document.getElementById('ww-step-2');
        step2.classList.remove('hidden');
        step2.classList.add('flex');

        // Draw segments
        const spinner = document.getElementById('ww-spinner');
        spinner.innerHTML = ''; // Clear previous text
        const count = products.length;
        const deg = 360 / count;
        let grad = 'conic-gradient(';
        for (let i = 0; i < count; i++) {
            // Alternate dark grays
            const c = i % 2 === 0 ? '#1a1a1a' : '#222';
            grad += `${c} ${i * deg}deg ${(i + 1) * deg}deg${i === count - 1 ? '' : ', '}`;

            // Add Text
            const textAngle = i * deg + deg / 2;
            const textEl = document.createElement('div');
            // Adjust name: simple TR/EN fallback
            const pName = products[i].name_tr || products[i].name_en || products[i].name;
            // Truncate if too long
            const displayName = pName.length > 15 ? pName.substring(0, 15) + '...' : pName;

            textEl.textContent = displayName;
            textEl.className = 'absolute top-1/2 left-1/2 text-white text-[10px] sm:text-xs font-medium origin-left whitespace-nowrap overflow-hidden text-ellipsis';
            // 70px radius for text placement roughly
            textEl.style.width = '45%'; // Stretch to edge
            textEl.style.transform = `translateY(-50%) rotate(${textAngle - 90}deg) translate(20px, 0)`; // Rotate correctly
            textEl.style.textAlign = 'right';
            textEl.style.paddingRight = '10px';

            spinner.appendChild(textEl);
        }
        grad += ')';
        spinner.style.background = grad;
        spinner.style.transform = 'rotate(0deg)';

        const spinBtn = document.getElementById('ww-spin-btn');
        // Clear previous listener efficiently by cloning or just rewriting onclick (simple way for widget)
        spinBtn.onclick = () => this.spin(products);
    }

    spin(products) {
        if (this.state.isSpinning) return;
        this.state.isSpinning = true;

        const spinner = document.getElementById('ww-spinner');
        const count = products.length;
        const deg = 360 / count;
        const winnerIdx = Math.floor(Math.random() * count);

        // Math to land on top
        const centerAngle = (winnerIdx + 0.5) * deg;
        // Fix rotation: The pointer is at TOP (0 deg visual). 
        // 0 deg in logic usually points RIGHT or TOP depend on math. 
        // CSS rotate(0deg) is usually top or right. Let's assume standard starts at top = 0.
        // If 0 is top, to simplify, we want segment winnerIdx at top.
        // Segment i is from (i*deg) to ((i+1)*deg). Center is (i+0.5)*deg.
        // If we rotate by -centerAngle, that center is at 0 (Top).
        // Add random full spins (e.g. 5 * 360).
        // Also subtract 90 because text rotation logic might assume something else? 
        // Let's stick to standard logic: 
        // Final Rotation = (spins * 360) - centerAngle.
        // NOTE: My text logic: rotate(${textAngle - 90}deg) might mean 0 is Right. 
        // If conic gradient starts at 0 (top), then logic is fine.
        const targetRot = (360 * 5) - centerAngle;

        spinner.style.transform = `rotate(${targetRot}deg)`;

        setTimeout(() => {
            this.showResult(products[winnerIdx]);
            this.state.isSpinning = false;
        }, 4000);
    }

    showResult(product) {
        document.getElementById('ww-step-2').classList.add('hidden');
        document.getElementById('ww-step-2').classList.remove('flex');
        document.getElementById('ww-step-3').classList.remove('hidden');

        this.state.lastProduct = product;

        const pName = product.name_tr || product.name_en || product.name;
        const pDesc = product.description_tr || product.description_en || '';
        const pPrice = product.price;

        document.getElementById('ww-result-name').textContent = pName;
        // Show desc if exists
        const descEl = document.getElementById('ww-result-desc');
        if (descEl) descEl.textContent = pDesc;

        document.getElementById('ww-result-price').textContent = pPrice ? `${pPrice} ₺` : '';

        const imgEl = document.getElementById('ww-result-img');
        if (imgEl) {
            if (product.image_path) {
                imgEl.src = product.image_path.includes('/image/upload/') ? product.image_path.replace('/image/upload/', '/image/upload/q_auto,f_auto,w_400/') : product.image_path;
                imgEl.classList.remove('hidden');
            } else {
                imgEl.classList.add('hidden');
            }
        }

        const detailBtn = document.getElementById('ww-detail-btn');
        if (typeof this.data.onGoToProduct === 'function') {
            detailBtn.classList.remove('hidden');
        } else {
            detailBtn.classList.add('hidden');
        }
    }
}

export default WheelWidget;
